import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { RailingColorMap } from '../custom/railingColorMap';
import { RailingColorsService } from '../services/railing/services/railing-colors.service';
import { map, switchMap } from 'rxjs/operators';
import { StageService } from '../services/stage.service';
import { ConstantsService } from '../services/constants.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'app-edit-top-rail',
  templateUrl: './edit-top-rail.component.html',
  styleUrls: ['./edit-top-rail.component.scss']
})
export class EditTopRailComponent implements OnInit {
  private _currentParams: any;
  series150: boolean = true;
  series100: boolean = true;
  series300: boolean = true;
  series200: boolean = true;
  series250: boolean = false;
  series350: boolean = true;
  series450: boolean = true;
  series450WithoutCap: boolean = true;
  AlSeries150: boolean = false;
  wood2x4: boolean = false;
  compositeBetween: boolean = false;
  compositeTop: boolean = false;
  steelFlatBar: boolean = false;
  steelTubularRound: boolean = false;

  selectedTopRail = {
    series150: false,
    series100: false,
    series300: false,
    series200: false,
    series250: false,
    series350: false,
    series450: false,
    series450WithoutCap: false,
    AlSeries150: false,
    wood2x4: false,
    compositeBetween: false,
    compositeTop: false,
    steelFlatBar: false,
    steelTubularRound: false
  };
  railingType: string = '';
  @Output() step2Editer = new EventEmitter();
  railingColorsTest: { [key: string]: RailingColorMap } = {};
  topRailColors; // used in template
  colors;

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    private railingColorsService: RailingColorsService,
    private stageService: StageService,
    private constantsService: ConstantsService
  ) {
    this.dataForMenu.topRail.subscribe(value => this.setSelectedSettings(value));
  }

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }

  setTopRail(value: string) {
    this.dataForMenu.setTopRail(value);
  }

  ngOnInit() {
    this.dataForMenu.railingType
      .pipe(
        switchMap(value => {
          this.railingType = value;
          // Series 250 (new profile) is exclusive to the Modern kit
          this.series250 = this.railingType === 'Modern';
          switch (this.railingType) {
            case 'DesignRail': {
              this.series150 = true;
              this.series100 = true;
              this.series300 = true;
              this.series200 = true;
              this.series350 = true;
              this.series450 = true;
              this.series450WithoutCap = true;
              this.AlSeries150 = false;
              this.wood2x4 = false;
              this.compositeBetween = false;
              this.compositeTop = false;
              this.steelFlatBar = false;
              this.steelTubularRound = false;
              break;
            }
            case 'Wood': {
              this.series150 = false;
              this.series100 = false;
              this.series300 = false;
              this.series200 = false;
              this.series350 = false;
              this.series450 = false;
              this.series450WithoutCap = false;
              this.AlSeries150 = true;
              this.wood2x4 = true;
              this.compositeBetween = false;
              this.compositeTop = false;
              this.steelFlatBar = false;
              this.steelTubularRound = false;
              break;
            }
            case 'Composite': {
              this.series150 = false;
              this.series100 = false;
              this.series300 = false;
              this.series200 = false;
              this.series350 = false;
              this.series450 = false;
              this.series450WithoutCap = false;
              this.AlSeries150 = true;
              this.wood2x4 = false;
              this.compositeBetween = true;
              this.compositeTop = true;
              this.steelFlatBar = false;
              this.steelTubularRound = false;
              break;
            }
            case 'Steel flat bar': {
              this.series150 = false;
              this.series100 = false;
              this.series300 = false;
              this.series200 = false;
              this.series350 = false;
              this.series450 = false;
              this.series450WithoutCap = false;
              this.AlSeries150 = false;
              this.wood2x4 = false;
              this.compositeBetween = false;
              this.compositeTop = false;
              this.steelFlatBar = true;
              this.steelTubularRound = false;
              break;
            }
            case 'Steel round tubular': {
              this.series150 = false;
              this.series100 = false;
              this.series300 = false;
              this.series200 = false;
              this.series350 = false;
              this.series450 = false;
              this.series450WithoutCap = false;
              this.AlSeries150 = false;
              this.wood2x4 = false;
              this.compositeBetween = false;
              this.compositeTop = false;
              this.steelFlatBar = false;
              this.steelTubularRound = true;
              break;
            }
            case 'Modern': {
              // "Only 1 top rail, Series 250" (spec p.2 rule 4)
              this.series150 = false;
              this.series100 = false;
              this.series300 = false;
              this.series200 = false;
              this.series350 = false;
              this.series450 = false;
              this.series450WithoutCap = false;
              this.AlSeries150 = false;
              this.wood2x4 = false;
              this.compositeBetween = false;
              this.compositeTop = false;
              this.steelFlatBar = false;
              this.steelTubularRound = false;
              break;
            }
          }
          return this._getTopRailColorsForMenu();
        })
      )
      .subscribe();

    this.railingColorsService.addProductType.subscribe(obj => {
      if (this.railingColorsTest[this._currentParams.railingType].railingElements[obj.colorType]) {
        this.railingColorsTest[this._currentParams.railingType].railingElements[
          obj.colorType
        ].addProductType(obj.productType);
        this.railingColorsService.updateColorMap(this.railingColorsTest);
      }
    });
  }

  setSelectedSettings(value) {
    switch (value) {
      case '150s': {
        this.clearSelection();
        this.selectedTopRail.series150 = true;
        break;
      }
      case '100s': {
        this.clearSelection();
        this.selectedTopRail.series100 = true;
        break;
      }
      case '300s': {
        this.clearSelection();
        this.selectedTopRail.series300 = true;
        break;
      }
      case '200s': {
        this.clearSelection();
        this.selectedTopRail.series200 = true;
        break;
      }
      case '250s': {
        this.clearSelection();
        this.selectedTopRail.series250 = true;
        break;
      }
      case '350s': {
        this.clearSelection();
        this.selectedTopRail.series350 = true;
        break;
      }
      case 'Low-Profile for Wood': {
        this.clearSelection();
        this.selectedTopRail.series450 = true;
        break;
      }
      case '450sWithoutCap': {
        this.clearSelection();
        this.selectedTopRail.series450WithoutCap = true;
        break;
      }
      case '150s': {
        this.clearSelection();
        this.selectedTopRail.AlSeries150 = true;
        break;
      }
      case 'Wood 2x4': {
        this.clearSelection();
        this.selectedTopRail.wood2x4 = true;
        break;
      }
      case 'CompositeBetween': {
        this.clearSelection();
        this.selectedTopRail.compositeBetween = true;
        break;
      }
      case 'CompositeTop': {
        this.clearSelection();
        this.selectedTopRail.compositeTop = true;
        break;
      }
      case 'Steel Flatbar': {
        this.clearSelection();
        this.selectedTopRail.steelFlatBar = true;
        break;
      }
      case 'Steel Tubular': {
        this.clearSelection();
        this.selectedTopRail.steelTubularRound = true;
        break;
      }
    }
  }

  clearSelection() {
    this.selectedTopRail = {
      series150: false,
      series100: false,
      series300: false,
      series200: false,
      series250: false,
      series350: false,
      series450: false,
      series450WithoutCap: false,
      AlSeries150: false,
      wood2x4: false,
      compositeBetween: false,
      compositeTop: false,
      steelFlatBar: false,
      steelTubularRound: false
    };
  }

  // choose color for top rail start
  // (only for -450-)
  private _getModifiedColors() {
    return this.railingColorsService.getColors().pipe(
      map(colors =>
        colors.map(color => {
          if (color.texture) color.texture = color.texture.replace('upload', 'download');
          return color;
        })
      )
    );
  }

  private _getColors() {
    if (this.colors) {
      return of(this.colors);
    } else {
      return forkJoin(this.railingColorsService.getColorGroups(), this._getModifiedColors()).pipe(
        map(([groups, colors]) => {
          const colorIds = new Set(groups[2].colors);
          this.colors = colors.filter(color => colorIds.has(color.id));
          return this.colors;
        })
      );
    }
  }

  private _generateColorsToRail(menuItem) {
    const modelsOnStage = this.stageService.getChildren();
    for (let i = 0; i < modelsOnStage.length; i++) {
      for (let j = 0; j < modelsOnStage[i].children.length; j++) {
        const entity = modelsOnStage[i].userData.entity;
        if (entity) {
          if (
            this.railingColorsTest[this._currentParams.railingType].railingElements[
              menuItem.type
            ].productTypes.some(el => el === entity.productType)
          ) {
            this.railingColorsService.setExistingColor(modelsOnStage[i], menuItem.type);
          }
        }
      }
    }
  }

  private _getTopRailColorsForMenu() {
    this._currentParams = this.dataForMenu.getCurrentParams();
    if (!this.railingColorsTest[this._currentParams.railingType]) {
      this.railingColorsTest[this._currentParams.railingType] = new RailingColorMap(
        this._currentParams.railingType,
        {
          'Top Cap': this.constantsService.defaultColors[this._currentParams.railingType]['Top Cap']
        }
      );
    }

    this.topRailColors = this.railingColorsTest[this._currentParams.railingType].railingElements[
      'Top Cap'
    ];

    return this._getColors().pipe(
      map(colors => {
        this.topRailColors.setColors(colors);

        if (!this.topRailColors.selected && this._currentParams.railingType !== 'Wood') {
          this.topRailColors.setDefaultColor(colors);
        } else if (!this.topRailColors.selected && this._currentParams.railingType === 'Wood') {
          this.topRailColors.setDefaultColor(colors);
        }

        this.railingColorsService.updateColorMap(this.railingColorsTest);
        this.dataForMenu.updateColorMap(this.railingColorsTest);
      })
    );
  }

  selectTypeColor(type, selected) {
    type.selected = selected;

    this.railingColorsTest[this._currentParams.railingType].railingElements[
      type.type
    ].setSelectedColor(selected);
    this._generateColorsToRail(
      this.railingColorsTest[this._currentParams.railingType].railingElements[type.type]
    );
    this.railingColorsService.updateColorMap(this.railingColorsTest);
  }
  // choose color for top rail end
}



// WEBPACK FOOTER //
// ./src/app/edit-top-rail/edit-top-rail.component.ts